export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-problem-2.a0741c0f.png";